export class RetriableError extends Error {}
export class FatalError extends Error {}
export interface SseEvent {
  audience?: number;
  from?: number;
  previewText?: string;
  type?: string;
  contextId?: number | string;
  timestamp?: Date;
  context?: Record<string, string>;
}
